<template>
  <v-footer color="#1D1D1B" class="white--text py-12">
    <v-layout justify-center>
      <v-flex xs12 md11>
        <v-layout mx-5 mb-7 pt-12 :class="{'column':$vuetify.breakpoint.smAndDown}">
          <v-flex xs4 class="text-left" :class="{'mb-5':$vuetify.breakpoint.smAndDown}">

            <v-layout justify-start>
              <v-flex shrink mr-5 mb-5>
                <template v-if="footer.logo_opm_url">
                  <a :href="footer.logo_opm_url">
                    <img src="../assets/icon/footer-link-1.svg"/>
                  </a>
                </template>
                <template v-else>
                  <img src="../assets/icon/footer-link-1.svg"/>
                </template>
              </v-flex>
              <v-flex shrink mb-5>
                <template v-if="footer.logo_site_url">
                  <a :href="footer.logo_site_url">
                    <img src="../assets/icon/footer-link-2.svg"/>
                  </a>
                </template>
                <template v-else>
                  <img src="../assets/icon/footer-link-2.svg"/>
                </template>
              </v-flex>
            </v-layout>
            <!--            <v-layout column>-->
            <!--              <v-flex mb-7>-->
            <!--                <div class="mb-5">-->
            <!--                  <span-->
            <!--                    class="footer-head"-->
            <!--                    @click="openLink('https://www.cea.or.th/statistics#tab-a')"-->
            <!--                  >CREATIVE ECONOMY REVIEW</span>-->
            <!--                </div>-->
            <!--                <div>-->
            <!--                  <span-->
            <!--                    class="footer-detail"-->
            <!--                    @click="openLink('https://www.cea.or.th/statistics#tab-a')"-->
            <!--                  >ข้อมูลและสถิติ</span>-->
            <!--                </div>-->
            <!--                <div>-->
            <!--                  <span-->
            <!--                    class="footer-detail"-->
            <!--                    @click="openLink('https://www.cea.or.th/statistics#tab-b')"-->
            <!--                  >รายงานและผลงานวิจัย</span>-->
            <!--                </div>-->
            <!--              </v-flex>-->
            <!--              <v-flex mb-7>-->
            <!--                <div class="mb-5">-->
            <!--                  <span-->
            <!--                    class="footer-head"-->
            <!--                    @click="openLink('https://www.cea.or.th/creative-district')"-->
            <!--                  >CREATIVE DISTRICTS</span>-->
            <!--                </div>-->
            <!--                <div>-->
            <!--                  <span-->
            <!--                    class="footer-detail"-->
            <!--                    @click="openLink('https://www.cea.or.th/creative-district')"-->
            <!--                  >ย่านเศรษฐกิจสร้างสรรค์คืออะไร</span>-->
            <!--                </div>-->
            <!--                <div>-->
            <!--                  <span-->
            <!--                    class="footer-detail"-->
            <!--                    @click="openLink('https://www.cea.or.th/creative-district-bangkok')"-->
            <!--                  >กรุงเทพฯ</span>-->
            <!--                </div>-->
            <!--                <div>-->
            <!--                  <span-->
            <!--                    class="footer-detail"-->
            <!--                    @click="openLink('https://www.cea.or.th/creative-district-chiang-mai')"-->
            <!--                  >เชียงใหม่</span>-->
            <!--                </div>-->
            <!--                <div>-->
            <!--                  <span-->
            <!--                    class="footer-detail"-->
            <!--                    @click="openLink('https://www.cea.or.th/creative-district-khon-kaen')"-->
            <!--                  >ขอนแก่น</span>-->
            <!--                </div>-->
            <!--              </v-flex>-->
            <!--              <v-flex mb-5>-->
            <!--                <span-->
            <!--                  class="footer-head"-->
            <!--                  @click="openLink('https://www.cea.or.th/projects')"-->
            <!--                >PROJECTS</span>-->
            <!--              </v-flex>-->
            <!--              <v-flex mb-5>-->
            <!--                <span class="footer-head" @click="openLink('https://www.cea.or.th/network')">NETWORK</span>-->
            <!--              </v-flex>-->
            <!--              <v-flex mb-5>-->
            <!--                <span-->
            <!--                  class="footer-head"-->
            <!--                  @click="openLink('https://www.facebook.com/CreativeEconomyAgency/')"-->
            <!--                >FACEBOOK</span>-->
            <!--              </v-flex>-->
            <!--            </v-layout>-->
          </v-flex>
<!--          <v-flex xs4 class="text-left" :class="{'mb-5':$vuetify.breakpoint.smAndDown}">-->
<!--            <div class="mb-4 footer-link">-->
<!--              <template v-if="footer.creative_economy_review_url">-->
<!--                <a :href="footer.creative_economy_review_url">-->
<!--                  <span class="footer-head text-uppercase">{{ $t('site.footer.overview') }}</span>-->
<!--                </a>-->
<!--              </template>-->
<!--              <template v-else>-->
<!--                <span class="footer-head text-uppercase">{{ $t('site.footer.overview') }}</span>-->
<!--              </template>-->
<!--            </div>-->
<!--            <div class="mb-4 footer-link">-->
<!--              <template v-if="footer.data_and_statistics_url">-->
<!--                <a :href="footer.data_and_statistics_url">-->
<!--                  <span class="footer-head text-uppercase">{{ $t('data-and-statistic')}}</span>-->
<!--                </a>-->
<!--              </template>-->
<!--              <template v-else>-->
<!--                <span class="footer-head text-uppercase">{{ $t('data-and-statistic')}}</span>-->
<!--              </template>-->
<!--            </div>-->
<!--            <div class="mb-4 footer-link">-->
<!--              <template v-if="footer.research_and_report_url">-->
<!--                <a :href="footer.research_and_report_url">-->
<!--                  <span class="footer-head text-uppercase">{{ $t('research-report')}}</span>-->
<!--                </a>-->
<!--              </template>-->
<!--              <template v-else>-->
<!--                <span class="footer-head text-uppercase">{{ $t('research-report')}}</span>-->
<!--              </template>-->
<!--            </div>-->
<!--            <div class="mb-4 footer-link">-->
<!--              <template v-if="footer.c_index_url">-->
<!--                <a :href="footer.c_index_url">-->
<!--                  <span class="footer-head text-uppercase">{{ $t('creativity-index')}}</span>-->
<!--                </a>-->
<!--              </template>-->
<!--              <template v-else>-->
<!--                <span class="footer-head text-uppercase">{{ $t('creativity-index')}}</span>-->
<!--              </template>-->
<!--            </div>-->
<!--            <div class="mb-4 footer-link">-->
<!--              <template v-if="footer.about_url">-->
<!--                <a :href="footer.about_url">-->
<!--                  <span class="footer-head text-uppercase">{{ $t('about')}}</span>-->
<!--                </a>-->
<!--              </template>-->
<!--              <template v-else>-->
<!--                <span class="footer-head text-uppercase">{{ $t('about')}}</span>-->
<!--              </template>-->
<!--            </div>-->
<!--            &lt;!&ndash;            <v-layout column>&ndash;&gt;-->
<!--            &lt;!&ndash;              <v-flex mb-7>&ndash;&gt;-->
<!--            &lt;!&ndash;                <div class="mb-7">&ndash;&gt;-->
<!--            &lt;!&ndash;                  <span class="footer-head" @click="openLink('https://www.cea.or.th/about')">ABOUT</span>&ndash;&gt;-->
<!--            &lt;!&ndash;                </div>&ndash;&gt;-->
<!--            &lt;!&ndash;                <div class="mb-3">&ndash;&gt;-->
<!--            &lt;!&ndash;                  <span class="footer-detail" @click="openLink('https://www.cea.or.th/about')">&ndash;&gt;-->
<!--            &lt;!&ndash;                    <b>รู้จักสำนักงานส่งเสริมเศรษฐกิจสร้างสรรค์</b>&ndash;&gt;-->
<!--            &lt;!&ndash;                  </span>&ndash;&gt;-->
<!--            &lt;!&ndash;                </div>&ndash;&gt;-->
<!--            &lt;!&ndash;                <div>&ndash;&gt;-->
<!--            &lt;!&ndash;                  <span&ndash;&gt;-->
<!--            &lt;!&ndash;                    class="footer-detail"&ndash;&gt;-->
<!--            &lt;!&ndash;                    @click="openLink('https://www.cea.or.th/background')"&ndash;&gt;-->
<!--            &lt;!&ndash;                  >ความเป็นมา</span>&ndash;&gt;-->
<!--            &lt;!&ndash;                </div>&ndash;&gt;-->
<!--            &lt;!&ndash;                <div>&ndash;&gt;-->
<!--            &lt;!&ndash;                  <span&ndash;&gt;-->
<!--            &lt;!&ndash;                    class="footer-detail"&ndash;&gt;-->
<!--            &lt;!&ndash;                    @click="openLink('https://www.cea.or.th/vision')"&ndash;&gt;-->
<!--            &lt;!&ndash;                  >วิสัยทัศน์ ภารกิจ</span>&ndash;&gt;-->
<!--            &lt;!&ndash;                </div>&ndash;&gt;-->
<!--            &lt;!&ndash;                <div>&ndash;&gt;-->
<!--            &lt;!&ndash;                  <span&ndash;&gt;-->
<!--            &lt;!&ndash;                    class="footer-detail"&ndash;&gt;-->
<!--            &lt;!&ndash;                    @click="openLink('https://www.cea.or.th/organization')"&ndash;&gt;-->
<!--            &lt;!&ndash;                  >โครงสร้างองค์กร</span>&ndash;&gt;-->
<!--            &lt;!&ndash;                </div>&ndash;&gt;-->
<!--            &lt;!&ndash;                <div>&ndash;&gt;-->
<!--            &lt;!&ndash;                  <span&ndash;&gt;-->
<!--            &lt;!&ndash;                    class="footer-detail"&ndash;&gt;-->
<!--            &lt;!&ndash;                    @click="openLink('https://www.cea.or.th/cea-committee')"&ndash;&gt;-->
<!--            &lt;!&ndash;                  >คณะกรรมการ</span>&ndash;&gt;-->
<!--            &lt;!&ndash;                </div>&ndash;&gt;-->
<!--            &lt;!&ndash;                <div>&ndash;&gt;-->
<!--            &lt;!&ndash;                  <span&ndash;&gt;-->
<!--            &lt;!&ndash;                    class="footer-detail"&ndash;&gt;-->
<!--            &lt;!&ndash;                    @click="openLink('https://www.cea.or.th/cea-director')"&ndash;&gt;-->
<!--            &lt;!&ndash;                  >คณะผู้บริหาร</span>&ndash;&gt;-->
<!--            &lt;!&ndash;                </div>&ndash;&gt;-->
<!--            &lt;!&ndash;              </v-flex>&ndash;&gt;-->
<!--            &lt;!&ndash;              <v-flex mb-7>&ndash;&gt;-->
<!--            &lt;!&ndash;                <div class="mb-3">&ndash;&gt;-->
<!--            &lt;!&ndash;                  <span&ndash;&gt;-->
<!--            &lt;!&ndash;                    class="footer-detail"&ndash;&gt;-->
<!--            &lt;!&ndash;                    @click="openLink('https://www.cea.or.th/rules-and-regulation')"&ndash;&gt;-->
<!--            &lt;!&ndash;                  >&ndash;&gt;-->
<!--            &lt;!&ndash;                    <b>การกำกับดูแลกิจการ</b>&ndash;&gt;-->
<!--            &lt;!&ndash;                  </span>&ndash;&gt;-->
<!--            &lt;!&ndash;                </div>&ndash;&gt;-->
<!--            &lt;!&ndash;                <div>&ndash;&gt;-->
<!--            &lt;!&ndash;                  <span&ndash;&gt;-->
<!--            &lt;!&ndash;                    class="footer-detail"&ndash;&gt;-->
<!--            &lt;!&ndash;                    @click="openLink('https://www.cea.or.th/rules-and-regulation')"&ndash;&gt;-->
<!--            &lt;!&ndash;                  >กฎระเบียบและข้อบังคับ</span>&ndash;&gt;-->
<!--            &lt;!&ndash;                </div>&ndash;&gt;-->
<!--            &lt;!&ndash;                <div>&ndash;&gt;-->
<!--            &lt;!&ndash;                  <span&ndash;&gt;-->
<!--            &lt;!&ndash;                    class="footer-detail"&ndash;&gt;-->
<!--            &lt;!&ndash;                    @click="openLink('https://www.cea.or.th/corporate-governance')"&ndash;&gt;-->
<!--            &lt;!&ndash;                  >การกำกับดูแลกิจการ</span>&ndash;&gt;-->
<!--            &lt;!&ndash;                </div>&ndash;&gt;-->
<!--            &lt;!&ndash;                <div>&ndash;&gt;-->
<!--            &lt;!&ndash;                  <span&ndash;&gt;-->
<!--            &lt;!&ndash;                    class="footer-detail"&ndash;&gt;-->
<!--            &lt;!&ndash;                    @click="openLink('https://www.cea.or.th/ita')"&ndash;&gt;-->
<!--            &lt;!&ndash;                  >การเปิดเผยข้อมูลสาธารณะ ITA</span>&ndash;&gt;-->
<!--            &lt;!&ndash;                </div>&ndash;&gt;-->
<!--            &lt;!&ndash;              </v-flex>&ndash;&gt;-->
<!--            &lt;!&ndash;              <v-flex>&ndash;&gt;-->
<!--            &lt;!&ndash;                <div>&ndash;&gt;-->
<!--            &lt;!&ndash;                  <span&ndash;&gt;-->
<!--            &lt;!&ndash;                    class="footer-detail"&ndash;&gt;-->
<!--            &lt;!&ndash;                    @click="openLink('https://www.cea.or.th/plan-report')"&ndash;&gt;-->
<!--            &lt;!&ndash;                  >แผนและผลการดำเนินงาน</span>&ndash;&gt;-->
<!--            &lt;!&ndash;                </div>&ndash;&gt;-->
<!--            &lt;!&ndash;                <div>&ndash;&gt;-->
<!--            &lt;!&ndash;                  <span&ndash;&gt;-->
<!--            &lt;!&ndash;                    class="footer-detail"&ndash;&gt;-->
<!--            &lt;!&ndash;                    @click="openLink('https://www.cea.or.th/e-service')"&ndash;&gt;-->
<!--            &lt;!&ndash;                  >E-service</span>&ndash;&gt;-->
<!--            &lt;!&ndash;                </div>&ndash;&gt;-->
<!--            &lt;!&ndash;                <div>&ndash;&gt;-->
<!--            &lt;!&ndash;                  <span&ndash;&gt;-->
<!--            &lt;!&ndash;                    class="footer-detail"&ndash;&gt;-->
<!--            &lt;!&ndash;                    @click="openLink('https://procurement.tcdc.or.th/th/announcement')"&ndash;&gt;-->
<!--            &lt;!&ndash;                  >จัดซื้อจัดจ้าง</span>&ndash;&gt;-->
<!--            &lt;!&ndash;                </div>&ndash;&gt;-->
<!--            &lt;!&ndash;                <div>&ndash;&gt;-->
<!--            &lt;!&ndash;                  <span&ndash;&gt;-->
<!--            &lt;!&ndash;                    class="footer-detail"&ndash;&gt;-->
<!--            &lt;!&ndash;                    @click="openLink('https://hr.tcdc.or.th/')"&ndash;&gt;-->
<!--            &lt;!&ndash;                  >ร่วมงานกับเรา</span>&ndash;&gt;-->
<!--            &lt;!&ndash;                </div>&ndash;&gt;-->
<!--            &lt;!&ndash;                <div>&ndash;&gt;-->
<!--            &lt;!&ndash;                  <span&ndash;&gt;-->
<!--            &lt;!&ndash;                    class="footer-detail"&ndash;&gt;-->
<!--            &lt;!&ndash;                    @click="openLink('https://www.cea.or.th/news-update')"&ndash;&gt;-->
<!--            &lt;!&ndash;                  >ข่าวประชาสัมพันธ์</span>&ndash;&gt;-->
<!--            &lt;!&ndash;                </div>&ndash;&gt;-->
<!--            &lt;!&ndash;                <div>&ndash;&gt;-->
<!--            &lt;!&ndash;                  <span&ndash;&gt;-->
<!--            &lt;!&ndash;                    class="footer-detail"&ndash;&gt;-->
<!--            &lt;!&ndash;                    @click="openLink('https://www.cea.or.th/contact-us')"&ndash;&gt;-->
<!--            &lt;!&ndash;                  >ติดต่อเรา</span>&ndash;&gt;-->
<!--            &lt;!&ndash;                </div>&ndash;&gt;-->
<!--            &lt;!&ndash;                <div>&ndash;&gt;-->
<!--            &lt;!&ndash;                  <span&ndash;&gt;-->
<!--            &lt;!&ndash;                    class="footer-detail"&ndash;&gt;-->
<!--            &lt;!&ndash;                    @click="openLink('https://www.cea.or.th/contact-complaint-form')"&ndash;&gt;-->
<!--            &lt;!&ndash;                  >ร้องเรียนทุจริต</span>&ndash;&gt;-->
<!--            &lt;!&ndash;                </div>&ndash;&gt;-->
<!--            &lt;!&ndash;              </v-flex>&ndash;&gt;-->
<!--            &lt;!&ndash;            </v-layout>&ndash;&gt;-->
<!--          </v-flex>-->
          <v-spacer></v-spacer>
          <v-flex xs4 class="text-left" :class="{'mb-5':$vuetify.breakpoint.smAndDown}">

            <v-layout mb-2>
              <v-flex shrink mr-3>
                <v-icon dark>room</v-icon>
              </v-flex>
              <v-flex shrink class="footer-detail-nonlink">
                {{ footer[`address_${language}`] }}
              </v-flex>
            </v-layout>

            <v-layout mb-2>
              <v-flex shrink mr-3>
                <v-icon dark>call</v-icon>
              </v-flex>
              <v-flex shrink class="footer-detail-nonlink">
                {{ $t('site.tel') }} {{ footer.tel }}
              </v-flex>
            </v-layout>

            <v-layout mb-2>
              <v-flex shrink mr-3>
                <v-icon dark>print</v-icon>
              </v-flex>
              <v-flex shrink class="footer-detail-nonlink">
                {{ $t('site.fax') }} {{ footer.fax }}
              </v-flex>
            </v-layout>

            <v-layout mb-2>
              <v-flex shrink mr-3>
                <template v-if="footer.email">
                  <a :href="`mailto:${footer.email}`">
                    <v-icon dark>mail</v-icon>
                  </a>
                </template>
                <template v-else>
                  <v-icon dark>mail</v-icon>
                </template>
              </v-flex>
              <v-flex shrink class="footer-detail">
                <template v-if="footer.email">
                  <a :href="`mailto:${footer.email}`">
                    {{ footer.email }}
                  </a>
                </template>
                <template v-else>
                  {{ footer.email }}
                </template>
              </v-flex>
            </v-layout>

            <v-layout mb-2>
              <v-flex shrink mr-3>
                <template v-if="footer.fb_url">
                  <a :href="footer.fb_url">
                    <v-icon dark>mdi-facebook</v-icon>
                  </a>
                </template>
                <template v-else>
                  <v-icon dark>mdi-facebook</v-icon>
                </template>
              </v-flex>
              <v-flex shrink class="footer-detail">
                <template v-if="footer.fb_url">
                  <a :href="footer.fb_url">
                    {{ footer[`fb_title_${ language }`] }}
                  </a>
                </template>
                <template v-else>
                  {{ footer[`fb_title_${ language }`] }}
                </template>
              </v-flex>
            </v-layout>
            <!--            <v-layout column>-->
            <!--              <v-flex mb-5>-->
            <!--                <div class="footer-detail-nonlink">สำนักงานส่งเสริมเศรษฐกิจสร้างสรรค์ (องค์การมหาชน)</div>-->
            <!--                <div class="footer-detail-nonlink">Creative Economy Agency (Public Organization)</div>-->
            <!--                <div class="footer-detail-nonlink">อาคารไปรษณีย์กลาง เลขที่ 1160 ถนนเจริญกรุง</div>-->
            <!--                <div class="footer-detail-nonlink">แขวงบางรัก เขตบางรัก กรุงเทพฯ 10500</div>-->
            <!--              </v-flex>-->
            <!--              <v-flex>-->
            <!--                <div class="footer-detail-nonlink">โทรศัพท์ (66) 2 105 7400</div>-->
            <!--                <div class="footer-detail-nonlink">โทรสาร (66) 2 105 7450</div>-->
            <!--                <div>-->
            <!--                  <span-->
            <!--                    class="footer-detail"-->
            <!--                    @click="openLink('mailto:info@cea.or.th')"-->
            <!--                  >info@cea.or.th</span>-->
            <!--                </div>-->
            <!--              </v-flex>-->
            <!--            </v-layout>-->
          </v-flex>
        </v-layout>

        <!--        <v-layout justify-start>-->
        <!--          <v-flex shrink>-->
        <!--            <img class="mx-5" src="../assets/icon/footer-link-1.svg" />-->
        <!--            <img class="mr-5" src="../assets/icon/footer-link-2.svg" />-->
        <!--          </v-flex>-->
        <!--        </v-layout>-->
      </v-flex>
    </v-layout>

    <!--        <v-layout>-->
    <!--            <v-flex class="justify-start align-center" style="display: flex">-->
    <!--                <img style="width: 110px" :src="require('../assets/cea-logo.png')">-->
    <!--            </v-flex>-->
    <!--            <v-flex class="justify-end align-center" style="display: flex">-->
    <!--                Copyright © 2019 CEA (Creative Economy Agency). All rights reserved. นโยบายความเป็นส่วนตัว ข้อกำหนดและเงื่อนไข-->
    <!--            </v-flex>-->
    <!--        </v-layout>-->
  </v-footer>
</template>

<script>
  import {mapState, mapActions} from 'vuex'

  export default {
    name: "Footer",
    computed: {
      ...mapState({
        language: state => state.locale.language,
        footer: state => state.site.footer
      })
    },
    created() {
      this.populateFooter()
    },
    methods: {
      ...mapActions('site', ['populateFooter']),
      openLink(link) {
        window.open(link);
      }
    }
  };
</script>

<style scoped>
  .footer-head {
    font-size: 14px;
    font-weight: bold;
    text-transform: uppercase;
    letter-spacing: 1px;
    cursor: pointer;
  }

  .footer-detail {
    font-size: 16px;
    cursor: pointer;
  }

  .footer-detail-nonlink {
    font-size: 16px;
  }

  .footer-detail:hover,
  .footer-head:hover,
  .v-application a:hover {
    color: #ff5100;
  }

  .v-application a {
    color: #fff;
    text-decoration: none;
  }

  pre {
    font-family: Kanit, sans-serif;
  }
</style>
